import { createAPIActions } from '../../utils/redux-actions';

export const plans = createAPIActions('PLANS');
export const subscription = createAPIActions('SUBSCRIPTION');
export const subscriptionCheckout = createAPIActions('SUBSCRIPTION_CHECKOUT');
export const subscriptionManagementLink = createAPIActions('SUBSCRIPTION_MANAGEMENT_LINK');
